export const fr = {
  landingPageForCompanies: {
    hero: {
      structure: "prefix_heading_suffix", // indicates heading is between text
      prefix: "Des équipes",
      suffix: "font du bénévolat ensemble"
    },
    hero_desc:
      "La plateforme d'engagement pour connecter, inspirer et fidéliser des employés extraordinaires. Vivez les valeurs de votre entreprise et faites le bien avec Purposely.",
    book_a_demo: "Réserver une démo",
    company_logos_desc:
      "Fait confiance par des équipes dédiées au bonheur des employés",
    summary_desc: "La plateforme de team building la plus impactante, point final.",
    summary_list_item_a: "Faites du bénévolat avec des associations à travers le monde",
    summary_list_item_b: "Trouvez des opportunités pour toutes les tailles d'équipe",
    summary_list_item_c: "Suivez l'impact de votre entreprise",
    summary_list_item_d: "Coordination sans effort avec les associations",
    volunteer_effortlessly: "Bénévolat sans effort",
    features: {
      volunteer: {
        title: "Bénévolat sans effort",
        description: "Logiciel pour trouver des opportunités et faire du bénévolat facilement",
        bullets: [
          "Trouvez des opportunités de bénévolat partout dans le monde. Vraiment !",
          "Nous gérons la coordination pour que les employés n'aient qu'à se présenter",
          "Des rappels automatisés gardent tout le monde sur la bonne voie"
        ]
      },
      track: {
        title: "Suivez l'impact",
        description: "Mesurez l'engagement de votre équipe",
        bullets: [
          "Obtenez un aperçu des intérêts de bénévolat de vos employés",
          "Suivez les heures et célébrez vos réalisations",
          "Ressentez tous ces sentiments chaleureux"
        ]
      },
      difference: {
        title: "Faites la différence ensemble",
        description: "Partagez la prochaine action solidaire avec votre équipe",
        bullets: [
          "Messages Slack automatisés pour les nouvelles opportunités",
          "Liens de partage en un clic avec tous les détails nécessaires",
          "Inspirez les autres avec un partage facile sur les réseaux sociaux"
        ]
      }
    },
    blogSection: {
      title: "Explorez notre blog",
      viewMore: "Voir plus",
      subtext: "Visitez notre blog pour les ressources associatives",
    },
    community: {
      title: "Rejoignez une communauté engagée",
      subtitle: "Purposely est un réseau rempli de champions, comme vous",
      perks: {
        connect: {
          alt: "Icône de cœur dans un carré arrondi jaune",
          text: "Connectez-vous avec des leaders de la culture d'entreprise"
        },
        learn: {
          alt: "Icône de personne dans un carré arrondi jaune",
          text: "Apprenez des experts du secteur associatif"
        },
        engage: {
          alt: "Icône de localisation dans un carré arrondi jaune",
          text: "Participez à des ateliers enrichissants"
        }
      },
      badge: {
        alt: "Badge de la communauté"
      }
    },
    whyVolunteering: {
      title: "Pourquoi le bénévolat compte pour votre entreprise",
      description: "Au-delà d'être une excellente contribution communautaire, le bénévolat est un investissement intelligent. Tout le monde bénéficie du sentiment formidable ressenti après avoir redonné à la communauté.",
      stats: {
        engagement: {
          stat: "2x",
          title: "Engagement",
          description: "Les employés bénévoles sont deux fois plus susceptibles d'être satisfaits de leur progression de carrière et de la culture d'entreprise"
        },
        retention: {
          stat: "1.5x",
          title: "Rétention",
          description: "Les bénévoles sont 1,5 fois plus susceptibles de rester à leur poste pendant les deux prochaines années"
        },
        satisfaction: {
          stat: "87%",
          title: "Satisfaction",
          description: "87% des employés bénévoles ont déclaré une plus grande fierté envers leur entreprise"
        },
        customers: {
          stat: "77%",
          title: "Clients",
          description: "77% des consommateurs sont motivés à acheter auprès d'entreprises engagées socialement"
        }
      }
    }
  }
}